import type { Catalogue } from './en.js';

/** Croatian interface catalogue. Typed against English: a missing key will not build. */
export const hr: Catalogue = {
  'common.back': 'Natrag',
  'common.cancel': 'Odustani',
  'common.close': 'Zatvori',
  'common.copy': 'Kopiraj poveznicu',
  'common.copied': 'Kopirano',
  'common.copyShort': 'Kopiraj',
  'common.loading': 'Učitavanje…',
  'common.save': 'Spremi',
  'common.signOut': 'Odjava',
  'common.settings': 'Postavke',
  'common.profile': 'Profil',
  'common.branding': 'Izgled razgovora',
  'common.search': 'Pretraži',
  'common.menu': 'Izbornik',
  'common.retry': 'Pokušaj ponovno',

  'error.generic': 'Nešto je pošlo po zlu.',
  'error.notFound': 'Nije pronađeno',
  'error.notFoundBody': 'Na ovoj adresi nema ničega.',

  'login.title': 'Prijava',
  'login.subtitle': 'Bez lozinki. Šaljemo vam jednokratnu poveznicu e-poštom.',
  'login.emailLabel': 'Adresa e-pošte',
  'login.submit': 'Pošalji mi poveznicu za prijavu',
  'login.sentTitle': 'Provjerite e-poštu',
  'login.sentBody':
    'Ako uz tu adresu postoji račun, poveznica za prijavu je na putu. Vrijedi {minutes} minuta i može se upotrijebiti jednom.',
  'login.sentNoticeTitle': 'Otvaranje poveznice vas samo po sebi neće prijaviti',
  'login.sentNoticeBody':
    'Bit ćete zamoljeni da pritisnete „Nastavi”. To je namjerno, kako skeneri e-pošte i pretpregledi poveznica ne bi potrošili vašu poveznicu prije vas.',
  'login.useDifferent': 'Upotrijebi drugu adresu',
  'login.emailNoticeTitle': 'Vaša adresa e-pošte nije end-to-end šifrirana',
  'login.emailNoticeBody':
    'Ona je zapis računa i služi za prijavu te za obavijest kada se netko pridruži nekoj od vaših poveznica. Sadržaj razgovora je odvojen i šifrira se u vašem pregledniku.',
  'login.failed': 'Poveznicu za prijavu nije bilo moguće poslati. Pokušajte ubrzo ponovno.',
  'login.backToStart': 'Natrag na početak',

  'confirm.checking': 'Provjera poveznice za prijavu…',
  'confirm.title': 'Dovršite prijavu',
  'confirm.subtitle': 'Još jedan korak, namjerno.',
  'confirm.as': 'Upravo se prijavljujete kao {email}.',
  'confirm.explain':
    'Zasad se ništa nije dogodilo. Ova poveznica još nije iskorištena i ostaje takva dok ne pritisnete „Nastavi” — zato vas skener koji je otvori ne može prijaviti.',
  'confirm.continue': 'Nastavi',
  'confirm.unavailable': 'Poveznica za prijavu nije dostupna',
  'confirm.expired': 'Ova poveznica za prijavu je istekla. Poveznice vrijede {minutes} minuta.',
  'confirm.used': 'Ova poveznica za prijavu već je iskorištena. Svaka poveznica radi jednom.',
  'confirm.invalid': 'Ova poveznica za prijavu nije valjana.',
  'confirm.requestNew': 'Zatraži novu poveznicu',
  'confirm.failed': 'Prijava nije uspjela. Zatražite novu poveznicu.',

  'messenger.newConversation': 'Nova poveznica',
  'messenger.newConversationHint':
    'Stvara privatnu poveznicu. Pošaljite je jednoj osobi; ona upiše ime i razgovor počinje.',
  'messenger.creatingLink': 'Stvaranje…',
  'messenger.someoneJoined': 'Netko se pridružio jednoj od vaših poveznica.',
  'messenger.searchPlaceholder': 'Pretraži',
  'messenger.clearSearch': 'Očisti pretragu',
  'messenger.filterAll': 'Sve',
  'messenger.filterUnread': 'Nepročitano',
  'messenger.filterActive': 'Aktivno',
  'messenger.filterEnded': 'Završeno',
  'messenger.emptyTitle': 'Još nema razgovora',
  'messenger.emptyBody': 'Izradite poveznicu i pošaljite je jednoj osobi da biste započeli.',
  'messenger.noMatch': 'Ništa ne odgovara ovoj pretrazi.',
  'messenger.loadingList': 'Učitavanje razgovora…',
  'messenger.welcomeTitle': 'Kairelo',
  'messenger.welcomeBody':
    'Pošaljite nekome poveznicu i razgovarajte {hours} sata. Poruke se šifriraju u vašem pregledniku i nakon toga ništa ne ostaje.',
  'messenger.encrypted': 'End-to-end šifrirano',
  'messenger.opening': 'Otvaranje razgovora…',
  'messenger.notOpenedYet':
    'Ovu pozivnicu još nitko nije otvorio. Postaje razgovor kada se netko pridruži.',
  'messenger.ended': 'Ovaj razgovor je završio. Nema zapisa.',
  'messenger.suspendedTitle': 'Račun je suspendiran',
  'messenger.suspendedBody': 'Postojeće poveznice su poništene, a nove nije moguće izraditi.',

  'row.unusedInvitation': 'Neiskorištena pozivnica',
  'row.invitationTitle': 'Pozivnica',
  'row.invitationWaiting': 'Čeka da bude otvorena',
  'row.invitationExpiresToday': 'Istječe danas',
  'row.invitationExpiresIn': 'Istječe za {days} dana',
  'row.visitor': 'Posjetitelj',
  'row.conversation': 'Razgovor',
  'row.notOpened': 'Pozivnica još nije otvorena',
  'row.ended': 'Ovaj razgovor je završio',
  'row.deleted': 'Izbrisano',
  'row.noKey': 'Nema ključa u ovom pregledniku',
  'row.joined': 'Pridružen',
  'row.joinedSayHello': 'Pridružen — pozdravite',
  'row.messageCount': 'Poruka: {count}',
  'row.messageCountOne': '1 poruka',
  'row.yesterday': 'Jučer',

  'chat.online': 'na mreži',
  'chat.offline': 'izvan mreže',
  'chat.typing': 'piše…',
  'chat.connecting': 'povezivanje…',
  'chat.reconnecting': 'ponovno povezivanje…',
  'chat.conversationEnded': 'završeno',
  'chat.back': 'Natrag na razgovore',
  'chat.about': 'O ovom razgovoru',
  'chat.report': 'Prijavi',
  'chat.encryptionBanner':
    'Poruke se šifriraju u vašem pregledniku. Ovaj razgovor završava sam od sebe i ne ostavlja zapis.',
  'chat.emptyWithKey': 'Još nema poruka. Sve što pošaljete najprije se ovdje šifrira.',
  'chat.emptyNoKey':
    'Ovaj preglednik nema ključ za ovaj razgovor pa se poruke ovdje ne mogu pročitati.',
  'chat.endedComposer': 'Ovaj razgovor je završio.',
  'chat.endNow': 'Završi razgovor odmah',
  'chat.endTitle': 'Završiti ovaj razgovor odmah?',
  'chat.endBody':
    'Pristup odmah prestaje za oboje, a šifrirana kopija koju usluga drži ulazi u brisanje po uobičajenom rasporedu.',
  'chat.endCaveat':
    'Ne može vratiti ništa što je druga osoba već vidjela, spremila ili snimila. Ništa ovdje to ne može.',
  'chat.endConfirm': 'Završi odmah',
  'chat.ended': 'Razgovor je završen.',
  'chat.endFailed': 'Razgovor nije bilo moguće završiti.',
  'chat.clearFromList': 'Ukloni s popisa',
  'chat.today': 'Danas',
  'chat.yesterday': 'Jučer',

  'message.unreadable': 'Šifrirana poruka koja se u ovom pregledniku ne može pročitati',
  'message.tapToDecrypt': 'Dodirnite za dešifriranje · {size}',
  'message.decrypting': 'Dešifriranje…',
  'message.couldNotOpen': 'Nije se moglo otvoriti',
  'message.decryptAndDownload': 'Dešifriraj i preuzmi',
  'message.save': 'Spremi {filename}',
  'message.testAdapter': 'testni adapter',
  'message.sending': 'Slanje',
  'message.sent': 'Poslano',
  'message.failed': 'Nije poslano',
  'message.playVoice': 'Reproduciraj glasovnu poruku',
  'message.pauseVoice': 'Pauziraj glasovnu poruku',
  'message.playbackPosition': 'Položaj reprodukcije',

  'composer.placeholder': 'Upišite poruku',
  'composer.disabled': 'Nema ključa u ovom pregledniku',
  'composer.emoji': 'Emoji',
  'composer.attach': 'Priloži',
  'composer.photosVideos': 'Fotografije i videozapisi',
  'composer.document': 'Dokument',
  'composer.record': 'Snimi glasovnu poruku',
  'composer.stopAndSend': 'Zaustavi snimanje i pošalji',
  'composer.cancelRecording': 'Odustani od snimanja',
  'composer.recording': 'Snimanje',
  'composer.send': 'Pošalji',
  'composer.notConnected': 'Niste povezani. Poruka nije poslana.',
  'composer.fileFailed': 'Tu datoteku nije bilo moguće poslati.',
  'composer.voiceFailed': 'Glasovna poruka nije poslana.',

  'invite.title': 'Poveznica pozivnice',
  'invite.subtitle': 'Prikazuje se jednom. Ključ koji sadrži nikada nije stigao do poslužitelja.',
  'invite.reveal': 'Kliknite za prikaz',
  'invite.revealLabel': 'Prikaži poveznicu pozivnice',
  'invite.copied': 'Poveznica je kopirana. Pošaljite je samo jednoj osobi.',
  'invite.failed': 'Poveznicu nije bilo moguće izraditi.',
  'invite.whatToKnow': 'Što trebate znati o ovoj poveznici',
  'invite.blockedTitle': 'Nove poveznice blokirane su u ovom pregledniku',
  'invite.notCreated':
    '{detail} Poveznica nije izrađena jer se ključ nije mogao zadržati u ovom pregledniku, pa bi razgovor bio nečitljiv.',

  'join.opening': 'Otvaranje pozivnice…',
  'join.defaultBio':
    '{name} koristi Kairelo za kratke, privatne razgovore. Poruke se šifriraju u vašem pregledniku, a ovaj razgovor završava sam od sebe i ne ostavlja zapis.',
  'join.invitedBy': 'Pozvani ste u privatni razgovor',
  'join.title': 'Pridružite se ovom razgovoru',
  'join.subtitle':
    'Odaberite ime pod kojim ćete biti prikazani. Šifrira se u vašem pregledniku pa ga usluga nikada ne vidi.',
  'join.nameLabel': 'Vaše prikazano ime',
  'join.namePlaceholder': 'Kako da vas zovu?',
  'join.nameHint':
    'Samo upisivanje ne čini ništa. Razgovor počinje tek kada pritisnete „Pridruži se”.',
  'join.submit': 'Pridruži se razgovoru',
  'join.failed': 'Pridruživanje nije uspjelo. Pokušajte ubrzo ponovno.',
  'join.trustEncrypted': 'Šifrirano u vašem pregledniku',
  'join.trustEnds': 'Završava nakon {hours} sata',
  'join.trustNoAccount': 'Račun nije potreban',
  'join.knowBefore': 'Što biste trebali znati prije pridruživanja',
  'join.unusableTitle': 'Ova poveznica se ne može upotrijebiti',
  'join.claimed':
    'Netko se već pridružio ovom poveznicom. Svaka pozivnica prima točno jednog posjetitelja, a kasniji pokušaji odbijaju se i s ispravnom poveznicom.',
  'join.expired':
    'Ova pozivnica je istekla. Neiskorištene pozivnice vrijede 30 dana, a razgovor {hours} sata od početka.',
  'join.invalid': 'Ova poveznica pozivnice nije valjana.',
  'join.askForNew': 'Zatražite novu poveznicu od osobe koja vam ju je poslala.',
  'join.incompleteTitle': 'Ova poveznica je nepotpuna',
  'join.incompleteBody':
    'Dio nakon znaka # sadrži ključ koji dešifrira ovaj razgovor. Nikada ne stiže do poslužitelja pa se ne može potražiti ni ponovno poslati.',
  'join.incompleteHint':
    'Poveznica je vjerojatno skraćena, odrezana u aplikaciji za poruke ili kopirana bez završetka. Zatražite ponovno cijelu poveznicu.',

  'visitor.languageNote':
    'Sprema se samo u ovom pregledniku. Određuje sučelje i jezik na koji se prevode poruke koje primate.',
  'visitor.reconnecting': 'Ponovno povezivanje…',
  'visitor.noSessionTitle': 'Ovaj preglednik nije dio ovog razgovora',
  'visitor.noSessionBody':
    'Pridruživanjem nastaje vjerodajnica sesije pohranjena u pregledniku koji se pridružio i nigdje drugdje. Ovaj preglednik je nema.',
  'visitor.noSessionRecovery':
    'Ako ste se pridružili ovdje pa obrisali podatke preglednika, razgovor se ne može vratiti — nema računa kao rezerve.',
  'visitor.endedTitle': 'Ovaj razgovor je završio',
  'visitor.endedBody':
    'Razdoblje od {hours} sata je prošlo. Nema zapisa, a šifrirana kopija koju je usluga držala čeka brisanje.',
  'visitor.goToStart': 'Na početak',

  'report.title': 'Prijavi ovaj razgovor',
  'report.subtitle': 'Sve što ovdje napišete šalje se nešifrirano i pohranjuje.',
  'report.warningTitle': 'Usluga ne može pročitati vaš razgovor',
  'report.warningBody':
    'Šifriran je pa se prijava ne može usporediti s njegovim sadržajem. Ono što napišete niže pohranjuje se u čitljivom obliku, zajedno s operativnim podacima poput vremenskih oznaka i vaše IP adrese.',
  'report.reason': 'Razlog',
  'report.reasonAbuse': 'Zlouporaba',
  'report.reasonHarassment': 'Uznemiravanje',
  'report.reasonIllegal': 'Nezakonit sadržaj',
  'report.reasonSpam': 'Neželjena pošta',
  'report.reasonOther': 'Ostalo',
  'report.details': 'Što se dogodilo',
  'report.detailsHint': 'Nije obavezno. Pohranjuje se nešifrirano.',
  'report.submit': 'Pošalji prijavu',
  'report.sentTitle': 'Prijava je zaprimljena',
  'report.sentBody': 'Prijava je zabilježena s operativnim podacima razgovora.',
  'report.thanks': 'Hvala',
  'report.failed': 'Prijavu nije bilo moguće poslati. Pokušajte ubrzo ponovno.',

  'settings.title': 'Postavke',
  'settings.languageTitle': 'Jezik',
  'settings.languageSubtitle': 'Za sučelje i za prijevod poruka koje primate.',
  'settings.languageLabel': 'Vaš jezik',
  'settings.languageHint':
    'Dolazne poruke prevode se na ovaj jezik na vašem uređaju. Ništa se ne šalje usluzi za prevođenje.',
  'settings.languageSaved': 'Jezik je spremljen.',
  'settings.languageFailed': 'Jezik nije bilo moguće spremiti.',
  'settings.interfaceUnavailableTitle': 'Prevođenje na uređaju nije dostupno u ovom pregledniku',
  'settings.interfaceUnavailableBody':
    'Vaš odabir jezika i dalje vrijedi za sučelje. Poruke će stizati na jeziku na kojem su napisane, jer bi njihovo prevođenje značilo slanje usluzi — što ovaj proizvod ne radi.',
  'settings.translationAvailableTitle': 'Prevođenje na uređaju je dostupno',
  'settings.translationAvailableBody':
    'Poruke koje primate automatski se prevode na vaš jezik u ovom pregledniku. Ništa se ne šalje servisu za prevođenje.',
  'settings.interfaceTitle': 'Sučelje',
  'settings.interfaceSubtitle':
    'Kako razgovor izgleda. Planiraju se dodatni stilovi; danas je dostupan samo jedan.',
  'settings.interfaceLabel': 'Stil sučelja',
  'settings.accountTitle': 'Vaš račun',
  'settings.backToConversations': 'Natrag na razgovore',
  'settings.uiTranslated': 'Sučelje prevedeno',
  'settings.uiEnglish': 'Sučelje na engleskom',
  'settings.uiEnglishNote':
    'Poruke se i dalje prevode na ovaj jezik; samo sučelje još nije prevedeno.',

  /* ------------------------------------------------------------ landing */
  'landing.heroLine1': 'Jedna soba.',
  'landing.heroLine2': 'Jedan razgovor.',
  'landing.heroLine3': 'Nestaje za 24 h.',
  'landing.heroBody':
    'Podijelite poveznicu. Druga osoba upiše ime i pridruži se. Razgovarate jedan dan, i onda je gotovo — bez transkripta, bez arhive, nema se što brisati.',
  'landing.signIn': 'Prijava e-poštom',
  'landing.noAccount': 'Bez računa. Bez preuzimanja.',
  'landing.ringLabel': 'i gotovo je',

  'landing.howTitle': 'Kako radi',
  'landing.step1Title': 'Podijelite poveznicu',
  'landing.step1Body': 'Stvorite poveznicu i podijelite je s jednom osobom.',
  'landing.step2Title': 'Ona upiše ime',
  'landing.step2Body': 'Bez računa, bez preuzimanja. Dovoljno je ime za prikaz.',
  'landing.step3Title': 'Razgovarajte 24 sata',
  'landing.step3Body': 'Nakon toga sve nestaje.',

  'landing.getTitle': 'Što dobivate',
  'landing.feature1Title': 'Podijelite privatnu poveznicu',
  'landing.feature1Body':
    'Vaš preglednik stvara ključ i stavlja ga u fragment poveznice — dio koji preglednici nikada ne šalju poslužitelju.',
  'landing.feature2Title': 'Upišite ime i pridružite se',
  'landing.feature2Body':
    'Bez registracije, bez računa, bez aplikacije. Druga osoba upiše ime za prikaz i počne razgovarati.',
  'landing.feature3Title': '24 sata i gotovo je',
  'landing.feature3Body':
    'Pristup prestaje, nema transkripta ni arhive, a šifrirana se kopija briše.',
  'landing.feature4Title': 'Šifrirano s kraja na kraj',
  'landing.feature4Body':
    'Poruke, fotografije, videozapisi, datoteke i glasovne poruke šifriraju se u vašem pregledniku prije slanja.',
  'landing.feature5Title': 'Mi to ne možemo pročitati',
  'landing.feature5Body':
    'U uobičajenom radu usluga prenosi i pohranjuje šifrirani tekst i nikada ne dobiva ključ.',

  'landing.carriesTitle': 'Što razgovor može sadržavati',
  'landing.carriesMessages': 'Poruke',
  'landing.carriesPhotos': 'Fotografije',
  'landing.carriesVideos': 'Videozapisi',
  'landing.carriesFiles': 'Datoteke',
  'landing.carriesVoice': 'Glasovne poruke',

  'landing.notTitle': 'Što ovo nije',
  'landing.notBody1':
    'Nije anonimno: usluga i dalje vidi IP adrese, vremenske oznake i podatke o pregledniku. Nije neovisno revidirana. Ne tvrdi se da je prikladna za reguliranu profesionalnu uporabu.',
  'landing.notBody2':
    'Razgovor se može čitati samo u profilu preglednika u kojem je stvoren ili u kojem se pristupilo. Izgubite li taj profil, razgovor je nečitljiv — svima, uključujući nas.',
  'landing.languageLabel': 'Jezik',

  /* -------------------------------------------------------- disclosures */
  'disclosure.copyingTitle': 'Sve na zaslonu može se kopirati',
  'disclosure.copyingBody':
    'Obje osobe mogu snimiti zaslon, snimiti ili fotografirati ovaj razgovor. Šifriranje sprječava uslugu da ga čita; ne može spriječiti osobu s kojom razgovarate da zadrži kopiju.',
  'disclosure.bearerTitle': 'Poveznicu tretirajte kao tajnu',
  'disclosure.bearerBody':
    'Dok se netko ne pridruži, tko god ima ovu poveznicu može se pridružiti prvi. Slanje e-poštom ili porukom, ili ostavljanje u povijesti međuspremnika, povijesti preglednika ili na snimci zaslona, može je izložiti izvan usluge. Pošaljite je jednoj osobi i samo toj osobi.',
  'disclosure.deviceKeyTitle': 'Samo ovaj preglednik može čitati ovaj razgovor',
  'disclosure.deviceKeyBody':
    'Ključ se stvara ovdje i ovdje ostaje. Prijava na drugom uređaju neće vam omogućiti čitanje, ni otvaranje obavijesti e-poštom negdje drugdje. Brisanje pohrane ovog preglednika, privatno pregledavanje ili gubitak ovog uređaja čini razgovor trajno nečitljivim. Oporavka nema.',
  'disclosure.scopeTitle': 'Što jest, a što nije šifrirano',
  'disclosure.scopeBody1':
    'Poruke, fotografije, videozapisi, datoteke, glasovne poruke i ime posjetitelja za prikaz šifriraju se u pregledniku. Profil vlasnika, e-adresa računa i operativni zapisi poput vremenskih oznaka i IP adresa nisu, i ne opisuju se kao šifrirani s kraja na kraj.',
  'disclosure.scopeBody2':
    'Budući da se kod za šifriranje isporučuje kao web-stranica, ugrožena instalacija ove usluge mogla bi poslužiti izmijenjeni kod. To je ograničenje šifriranja isporučenog preglednikom i ne može se ukloniti samim dizajnom. Kriptografija ovdje nije neovisno revidirana.',
  'disclosure.notAnonymousTitle': 'Bez registracije ne znači anonimno',
  'disclosure.notAnonymousBody':
    'Račun vam ne treba i vaše je ime za prikaz šifrirano. Usluga i dalje vidi operativne podatke poput vaše IP adrese, vremenskih oznaka i podataka o pregledniku, koje koristi za ograničavanje učestalosti i odgovor na zlouporabu.',
  'disclosure.temporaryTitle': 'Ovaj razgovor završava sam',
  'disclosure.temporaryBody':
    'Ostaje otvoren {hours} sati nakon početka. Nakon toga nijedna se strana ne može ponovno spojiti, nema transkripta, a usluga briše šifriranu kopiju koju drži. Sigurnosne kopije istječu zasebno, po vlastitom rasporedu.',
};
